import { useState } from 'react';
import { readExcelFile } from '@/utils/excel/core/fileReader';
import { parseB2BProductsFromExcel } from '@/utils/excel/parsers/b2bProductParser';
import { CreateB2BProductInput } from '@/types/database/b2b-products';

export const useB2BProductExcelParser = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [previewData, setPreviewData] = useState<CreateB2BProductInput[]>([]);
  const [errors, setErrors] = useState<string[]>([]);

  const processFile = async (file: File) => {
    setIsProcessing(true);
    setPreviewData([]);
    setErrors([]);

    try {
      console.log('Processing B2B products file:', file.name);
      
      const workbook = await readExcelFile(file);
      const { data, errors: parseErrors } = parseB2BProductsFromExcel(workbook);
      
      console.log('Parsed B2B products data:', data);
      console.log('Parse errors:', parseErrors);
      
      setPreviewData(data);
      setErrors(parseErrors);
      
      return { data, errors: parseErrors };
    } catch (error) {
      console.error('Error processing B2B products file:', error);
      const errorMessage = error instanceof Error ? error.message : 'Failed to process file';
      setErrors([errorMessage]);
      return { data: [], errors: [errorMessage] };
    } finally {
      setIsProcessing(false);
    }
  };

  const clearData = () => {
    setPreviewData([]);
    setErrors([]);
  };

  return {
    processFile,
    clearData,
    isProcessing,
    previewData,
    errors,
    hasData: previewData.length > 0,
    hasErrors: errors.length > 0,
  };
};